import React, {useEffect, useState} from "react";
import {Layout} from 'antd';
import Api from "../common/Api";

interface Columns {
    acc_credit: string;
    date_update: string;
    drivetrain_type: string;
    fuel_type: string;
    low_volume_mfr: string;
    manufacturer_id: string;
    nzev_miles: number;
    sold_to_ultimate: string;
    state_sold: string;
    update_user_name: string;
    veh_class: string;
    veh_my: number;
    veh_vin: string;
    vehicle_sales_id: number;
    zep_cert: string;
}

const columnAdaptor = (columns: Array<Columns>) => {
    if (columns.length < 1)
        return;
    return Object.keys(columns[0]).map((column) => ({
        title: column,
        dataIndex: column
    }))
}

const getVINs = async () => {
    return Api.management.getVINs();
}

const handleDelete = async ({
                                vehicleSaleIds,
                                hooks
                            }: { vehicleSaleIds: number[], hooks: [Columns[], React.Dispatch<React.SetStateAction<Columns[]>>] }) => {
    try {
        await Api.management.deleteDuplicates(vehicleSaleIds)
        const [data, setData] = hooks;
        const newArr = data.filter((value) => {
            return vehicleSaleIds.indexOf(value.vehicle_sales_id) === -1;
        })
        setData(newArr)
    } catch (e) {

    }
}

const VINsValidation = () => {
    const [data, setData] = useState<Array<Columns>>([])
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [url, setUrl] = useState<string>('');

    useEffect(() => {
        (async () => {
            setLoading(true);

            const {data} = await Api.quicksight.getEmbedURLs();
            setUrl(data.embedURLs[2]);
            const {data: apiData} = await getVINs()
            setData(apiData);
            setLoading(false);
        })();
    }, []);

    return (
        <>
            <h3>Duplicate VIN Check</h3>
            <Layout style={{height: "100%"}}>
                <iframe width="100%" title={"Quicksight"} height="100%" src={url}></iframe>
            </Layout>
        </>
    )
}

export default VINsValidation;
